
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.076 1.333h5.303c.962 0 1.742.78 1.742 1.743v9.848c0 .962-.78 1.743-1.742 1.743H5.076c-.962 0-1.743-.78-1.743-1.743V3.076c0-.962.78-1.743 1.743-1.743zm5.53 10.303H4.848V3.151h5.758v8.485zM7.727 13.71a.606.606 0 100-1.213.606.606 0 000 1.213z","fill":"#282E3E"}})])
          )
        }
      }
    